import React from 'react';
import './Paintings.css';

function Paintings() {
  const paintings = [
    {
      id: 1,
      title: "Abstract Symphony",
      artist: "Neon Horizons",
      image: "/images/paintings/painting1.png",
      price: "View on Auction",
      description: "A beautiful modern abstract painting with vibrant colors and gold accents."
    },
    {
      id: 2,
      title: "Cyberpunk Canvas",
      artist: "Digital Dreams",
      image: "/images/paintings/painting2.png",
      price: "View on Auction",
      description: "A stunning futuristic cyberpunk portrait painting of an artist in neon lights."
    },
    {
      id: 3,
      title: "Floating Islands",
      artist: "Ethereal Worlds",
      image: "/images/paintings/painting3.png",
      price: "View on Auction",
      description: "A breathtaking surreal landscape featuring floating islands and glowing waterfalls."
    }
  ];

  return (
    <div className="paintings-page">
      <div className="paintings-hero">
        <h1 className="paintings-title">Exclusive Art Gallery</h1>
        <p className="paintings-subtitle">
          Discover unique, premium artworks. Click on any piece to bid or purchase directly from our partner auction site.
        </p>
      </div>

      <div className="paintings-gallery">
        {paintings.map((painting) => (
          <div key={painting.id} className="painting-card">
            <div className="painting-image-container">
              <img src={painting.image} alt={painting.title} className="painting-image" />
            </div>
            <div className="painting-info">
              <h2 className="painting-name">{painting.title}</h2>
              <h3 className="painting-artist">by {painting.artist}</h3>
              <p className="painting-desc">{painting.description}</p>
              
              <a 
                href="https://thrillartsauction.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="painting-buy-button"
              >
                {painting.price}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Paintings;
